<template>
  <div class="mb-lg grid grid-cols-5 gap-1 mobile:grid-cols-1">
    <p class="my-auto text-lg font-bold">
      {{ title }}
    </p>
    <EditableArea
      v-if="brandImage"
      class="col-span-3 flex items-center gap-2 mobile:grid mobile:grid-cols-3 mobile:items-center mobile:justify-center mobile:gap-1"
      :content="brandImage"
    />
  </div>
</template>

<script lang="ts" setup>
// @ts-expect-error missing declaration file with types
import { EditableArea } from '@magnolia/vue-editor';

interface Props {
  title?: string;
  brandImage?: any;
}

withDefaults(defineProps<Props>(), {
  title: '',
  brandImage: undefined,
});
</script>
